import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getSlideShares = (searchTerm) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_SLIDESHARES(searchTerm),
    "",
    cancelToken
  );
};

export default getSlideShares;
